import { atom } from 'recoil';

const ShiftEditPaneAppendState = atom({
    key: 'shiftEditPaneAppendState',
    default: null
});

export default ShiftEditPaneAppendState;